import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberIdTypeForm from '../../../components/forms/MemberIdTypeForm';
import { useMemberIdTypeById, useUpdateMemberIdType } from '../../../hooks/useMemberIdTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberIdTypeDTO } from '../../../services/apiClient';

const MemberIdTypeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useMemberIdTypeById(id!);
  const updateMutation = useUpdateMemberIdType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Id Types', href: '/admin/memberidtypes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/memberidtypes');
    } catch (error) {
      console.error('Error updating MemberIdType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberidtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.MemberIdType.Edit"
    >
        {entityData ? (
          <MemberIdTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/memberidtypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default MemberIdTypeEdit;
